import React from 'react';
import PropTypes from 'prop-types';

export function AvailableQuantityOptions({ availableQuantities }) {
    return availableQuantities.map((availableQuantity, index) =>
        <option value={availableQuantity} key={index}>
            {availableQuantity}
        </option>,
    );
}

AvailableQuantityOptions.propTypes = {
    availableQuantities: PropTypes.arrayOf(PropTypes.number).isRequired,
};
